<template>
  <b-form data-vv-scope="company">
    <div class="d-flex flex-column" style="gap: 24px;">
      <div class="title">
        <h5>{{ $t("views.seller.my_account.text_1320") }}</h5>
        <p>{{ $t("views.seller.my_account.text_1322") }}</p>
      </div>
      <b-row>
        <b-col cols="12" md="6">
          <BaseInput 
            name="name_company"
            v-model="company.name"
            type="text" 
            v-validate="'required'"
            :placeholder="$t('views.seller.my_account.text_1177')"
            :label="$t('views.seller.my_account.text_1586')"
            :isValid="!errors.has('company.name_company')" 
            :errorMessage="$t('views.seller.my_account.text_1178')"
          />
        </b-col>

        <b-col cols="12" md="6">
          <BaseInput 
            name="fantasy_name"
            v-model="company.fantasy_name"
            type="text"
            maxlength="40"
            v-validate="'required'" 
            :label="$t('views.seller.my_account.text_1179')"
            :placeholder="$t('views.seller.my_account.text_1180')"
            :isValid="!errors.has('company.fantasy_name')" 
            :errorMessage="$t('views.seller.my_account.text_1178')"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="6">
          <BaseInput 
            name="cnpj"
            v-model="company.cnpj"
            type="text" 
            v-validate="'required|cpf_cnpj'"
            v-mask="['##.###.###/####-##']"
            :label="$t('views.seller.my_account.text_1181')"
            :placeholder="$t('views.seller.my_account.text_1182')"
            :isValid="!errors.has('company.cnpj')"
            :errorMessage="$t('views.seller.my_account.text_1587')"
          />
        </b-col>
        <b-col cols="12" md="6">
          <BaseInput 
            name="phone_company"
            v-model="company.telephone"
            type="text"
            v-mask="['(##) ####-####', '(##) #####-####']" 
            v-validate="'required'"
            :label="$t('views.seller.my_account.text_1570')"
            :placeholder="$t('views.seller.my_account.text_1590')"
            :isValid="!errors.has('company.phone_company')" 
            :errorMessage="$t('views.seller.my_account.text_1591')"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12">
          <BaseInputFile
            name="social_contract"
            sizeUnit="mb"
            v-model="files.social_contract"
            :label="$t('views.seller.my_account.text_1325')"
            :extensions="['pdf', 'jpg', 'png']"
            :maxSize="10"
            :instructionsLabel="$t('views.seller.my_account.text_1284')"
            :instructions="[
              { icon: 'gallery.png', label: this.$t('views.seller.my_account.text_1326')},
              { icon: 'document-text.png', label: this.$t('views.seller.my_account.text_1327')},
              { icon: 'gallery-tick.png', label: this.$t('views.seller.my_account.text_1328')},
            ]"
            :errorMessage="filesErrors.social_contract"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12">
          <BaseInputFile
            name="cnpj_card"
            sizeUnit="mb"
            v-model="files.cnpj_card"
            :label="$t('views.seller.my_account.text_1330')"
            :extensions="['pdf', 'jpg', 'png']"
            :maxSize="10"
            :instructionsLabel="$t('views.seller.my_account.text_1284')"
            :instructions="[
              { icon: 'gallery.png', label: this.$t('views.seller.my_account.text_1339')},
              { icon: 'document-text.png', label: this.$t('views.seller.my_account.text_1340')},
              { icon: 'gallery-tick.png', label: this.$t('views.seller.my_account.text_1341')},
            ]"
            :errorMessage="filesErrors.cnpj_card"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12">
          <BaseInputFile
            name="balance_sheet"
            sizeUnit="mb"
            v-model="files.balance_sheet"
            :label="$t('views.seller.my_account.text_1335')"
            :extensions="['pdf', 'jpg', 'png']"
            :maxSize="10"
            :instructionsLabel="$t('views.seller.my_account.text_1284')"
            :instructions="[
              { icon: 'gallery.png', label: this.$t('views.seller.my_account.text_1336')},
              { icon: 'gallery-tick.png', label: this.$t('views.seller.my_account.text_1337')},
            ]"
            :errorMessage="filesErrors.balance_sheet"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12">
          <BaseInputFile
            v-model="files.proof_address"
            name="proof_address"
            sizeUnit="mb"
            :label="$t('views.seller.my_account.text_1277')"
            :extensions="['pdf', 'jpg', 'png']"
            :maxSize="10"
            :instructionsLabel="$t('views.seller.my_account.text_1278')"
            :instructions="[
              { icon: 'gallery.png', label: this.$t('views.seller.my_account.text_1279')},
              { icon: 'document-text.png', label: this.$t('views.seller.my_account.text_1280')},
              { icon: 'gallery-tick.png', label: this.$t('views.seller.my_account.text_1281')},
            ]"
            :errorMessage="filesErrors.proof_address"
          />
        </b-col>
      </b-row>
    </div>
    <div class="divider"></div>
    <div class="d-flex flex-column" style="gap: 24px;">
			<div class="title">
				<h5>{{ $t("views.seller.my_account.text_1323") }}</h5>
				<p>{{ $t("views.seller.my_account.text_1324") }}</p>
			</div>

			<b-row>
				<b-col cols="12" md="6">
					<BaseInput 
            id="zip_code" 
            name="zip_code" 
            v-model="zipCode" 
            v-mask="['#####-###']" 
            type="text"
            v-validate="'required'"
            @input="debounce"
            :placeholder="$t('views.seller.my_account.text_1169')"
						:label="$t('views.seller.my_account.text_1578')"
            :isValid="!errors.has('company.zip_code')"
            :errorMessage="$t('views.seller.my_account.text_1301')"
          >
					</BaseInput>
				</b-col>
				<b-col cols="12" md="6">
					<BaseInput 
            id="street" 
            name="street" 
            v-model="address.street" 
            type="text"
            v-validate="'required'"
            :label="$t('views.seller.my_account.text_1170')"
						:placeholder="$t('views.seller.my_account.text_1276')" 
            :isValid="!errors.has('company.street')"
            :errorMessage="$t('views.seller.my_account.text_1302')"
          >
					</BaseInput>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="12" md="6">
					<BaseInput 
            id="number" 
            name="number" 
            v-model="address.number" 
            v-mask="['########']" 
            type="text"
            v-validate="'required'"
            :placeholder="$t('views.seller.my_account.text_1579')" 
						:label="$t('views.seller.my_account.text_1171')"
            :isValid="!errors.has('company.number')"
            :errorMessage="$t('views.seller.my_account.text_1303')"
          >
					</BaseInput>
				</b-col>
				<b-col cols="12" md="6">
					<BaseInput 
            id="neighborhood" 
            name="neighborhood" 
            v-model="address.neighborhood" 
            type="text"
            v-validate="'required'"
            :label="$t('views.seller.my_account.text_1580')"
						:placeholder="$t('views.seller.my_account.text_1172')" 
            :isValid="!errors.has('company.neighborhood')"
            :errorMessage="$t('views.seller.my_account.text_1304')"
          >
					</BaseInput>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="12" md="6">
					<BaseInput 
            id="city" 
            name="city" 
            v-model="address.city" 
            type="text"
            v-validate="'required'"
            :placeholder="$t('views.seller.my_account.text_1582')" 
						:label="$t('views.seller.my_account.text_1581')"
            :isValid="!errors.has('company.city')"
            :errorMessage="$t('views.seller.my_account.text_1305')"
          >
					</BaseInput>
				</b-col>
				<b-col cols="12" md="6">
					<BaseInput 
            id="state" 
            name="state" 
            v-model="address.state" 
            type="text"
            v-validate="'required'"
            :label="$t('views.seller.my_account.text_1583')"
						:placeholder="$t('views.seller.my_account.text_1584')" 
            :isValid="!errors.has('company.state')"
            :errorMessage="$t('views.seller.my_account.text_1306')"
          >
					</BaseInput>
				</b-col>
			</b-row>
		</div>
  </b-form>
</template>

<script>
export default {
  name: 'BusinessDataFormStep',
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      uploadedFile: null,
      fileErrorMessage: '',
      zipCode: '',
      address: {
        zip_code: '',
        street: '',
        number: '',
        neighborhood: '',
        city: '',
        state: '',
      },
      files: {
        social_contract: null,
        cnpj_card: null,
        balance_sheet: null,
        proof_address: null,
      },
      filesErrors: {
        social_contract: '',
        cnpj_card: '',
        balance_sheet: '',
        proof_address: ''
      },
      social_contract_id: null,
      cnpj_card_id: null,
      balance_sheet_id: null,
      proof_address_id: null
    }
  },
  watch: {
    files: {
      handler(newValue) {
        for (const key in newValue) {
          if (newValue[key]) {
            this.filesErrors[key] = '';
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    searchAddress(value) {
      if (!value) {
        return;
      }

      const zipCode = value.replace(/\D/g, '');

      if (zipCode.length < 8) {
        return;
      }

      fetch(`https://viacep.com.br/ws/${zipCode}/json/`)
        .then(response => response.json())
        .then(response => {
          this.address = {
            zip_code: value,
            street: response.logradouro,
            neighborhood: response.bairro,
            city: response.localidade,
            state: response.estado,
            number: this.address.number
          }
        });

    },
    debounce: _.debounce(function () {
      this.searchAddress(this.zipCode);
    }, 500),

    async validateForm() {
      try {
        const filesValiated = this.validateFiles();
        const formValiated = await this.$validator.validateAll('company');

        return (filesValiated && formValiated);
      } catch(error) {
        return false;
      }
    },
    async handleSubmit() {      
      try {
        const updatedCompany = { 
          company: {
            ...this.company,
            ...this.address 
          }
        };

        updatedCompany.company.documents = this.extractDocuments();
        return updatedCompany;
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    handleFileInvalid(type, message) {
      this.filesErrors[type] = message;
      this.files[type] = null;
    },

    validateFiles() {
      let isValid = true;

      for (const key in this.files) {
        if (key === 'cnpj_card') {
          continue;
        }
        if (this.files[key] === null) {
          isValid = false;
          this.filesErrors = {
            ...this.filesErrors,
            [key]: this.$t('views.seller.my_account.text_1338')
          }
        }
      }
      return isValid;
    },
    extractDocuments() {
      const documents = [];
      for (const key in this.files) {
        if (!this.files[key]) {
          continue;
        }

        if (this.files[key].size) {
          documents.push({
            file: this.files[key],
            subtype: key.toUpperCase(),
            id: this[`${key}_id`]
          });
        }
      }

      return documents;
    },
    fillDocuments(documents) {
      const socialContract = this.getDocument(documents, 'SOCIAL_CONTRACT');
      const cnpjCard = this.getDocument(documents, 'CNPJ_CARD');
      const balanceSheet = this.getDocument(documents, 'BALANCE_SHEET');
      const proofAddress = this.getDocument(documents, 'PROOF_ADDRESS');

      if (socialContract) {
        this.social_contract_id = socialContract.id;
        this.files.social_contract = this.fakeFile(socialContract, 'contrato-social');
      }
      if (cnpjCard) {
        this.cnpj_card_id = cnpjCard.id;
        this.files.cnpj_card = this.fakeFile(cnpjCard, 'cartao-cnpj');
      }
      if (balanceSheet) {
        this.balance_sheet_id = balanceSheet.id;
        this.files.balance_sheet = this.fakeFile(balanceSheet, 'balance-sheet');
      }
      if (proofAddress) {
        this.proof_address_id = proofAddress.id;
        this.files.proof_address = this.fakeFile(proofAddress, 'comprovante-endereco');
      }
    },
    getDocument(documents, subtype) {
      return documents
        .find(document => (document.type === 'COMPANY_DOCUMENT') && (document.subtype === subtype));
    },
    fakeFile(document, fileName) {
      const ext = document.path.split('.').pop().toLowerCase();
      const blob = new Blob();
      return new File([blob], `${fileName}.${ext}`);
    }
  },
  mounted() {
    if (!this.$root.myAccountData) {
      return;
    }
    const { company, user } = this.$root.myAccountData;

    if (company) {
      this.address = {
        street: company.street || '',
        neighborhood: company.neighborhood || '',
        city: company.city || '',
        state: company.state || '',
        number: company.number || ''
      };
      this.zipCode = company.zip_code || '';
    }

    if (user && user.documents && user.documents.length) {
      this.fillDocuments(user.documents);
    }

    this.$root.$on('onload-my-account', async ({ user }) => {
      if (user && user.documents && user.documents.length) {
        this.fillDocuments(user.documents);
      }
    });
  }
};
</script>
